import { PaymentCardType } from '@mews/enums';
import { PaymentCardImageTypes } from './PaymentCardImageTypes';

export interface PaymentCardTypeConfig {
    paymentCardType: PaymentCardType;
    type: keyof PaymentCardImageTypes;
    name: string;
    pattern: RegExp;
    format: RegExp;
    length: Array<number>;
    cvcLength: Array<number>;
    luhn: boolean;
}

const defaultFormat = /(\d{1,4})/g;

export const cardTypes: Array<PaymentCardTypeConfig> = [
    {
        paymentCardType: PaymentCardType.Maestro,
        type: 'maestro',
        name: 'Maestro',
        pattern: /^(5(018|0[23]|[68])|6(39|7))/,
        format: defaultFormat,
        length: [12, 13, 14, 15, 16, 17, 18, 19],
        cvcLength: [3],
        luhn: true,
    },
    {
        paymentCardType: PaymentCardType.Dankort,
        type: 'dankort',
        name: 'Dankort',
        pattern: /^5019/,
        format: defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true,
    },
    {
        paymentCardType: PaymentCardType.Visa,
        type: 'visa',
        name: 'Visa',
        pattern: /^4/,
        format: defaultFormat,
        length: [13, 16],
        cvcLength: [3],
        luhn: true,
    },
    {
        paymentCardType: PaymentCardType.MasterCard,
        type: 'mastercard',
        name: 'MasterCard',
        pattern: /^(5[0-5]|2[2-7])/,
        format: defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true,
    },
    {
        paymentCardType: PaymentCardType.Amex,
        type: 'amex',
        name: 'AmEx',
        pattern: /^3[47]/,
        format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
        length: [15],
        cvcLength: [3, 4],
        luhn: true,
    },
    {
        paymentCardType: PaymentCardType.DinersClub,
        type: 'dinersclub',
        name: 'Diners Club',
        pattern: /^3[0689]/,
        format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
        length: [14],
        cvcLength: [3],
        luhn: true,
    },
    {
        paymentCardType: PaymentCardType.Discover,
        type: 'discover',
        name: 'Discover',
        pattern: /^6([045]|22)/,
        format: defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true,
    },
    {
        paymentCardType: PaymentCardType.UnionPay,
        type: 'unionpay',
        name: 'Union Pay',
        pattern: /^(62|88)/,
        format: defaultFormat,
        length: [16, 17, 18, 19],
        cvcLength: [3],
        luhn: false,
    },
    {
        paymentCardType: PaymentCardType.Jcb,
        type: 'jcb',
        name: 'JCB',
        pattern: /^35/,
        format: defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true,
    },
];
